var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCueAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#3366FF;}\n\t.st3{fill:#0F1F4D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.7,128.8v-26.2c0-2.5,2-4.5,4.5-4.5h3.1l0-10.1c0-2.2-0.9-4.3-2.4-5.8c-1.6-1.6-3.6-2.4-5.8-2.4 L59,79.5c-4.5,0-8.3,3.7-8.3,8.2l-0.1,55.7c0,4.6,3.7,8.3,8.2,8.3l132,0.1c4.6,0,8.3-3.7,8.3-8.2l0-10.3h-3 C193.7,133.4,191.7,131.3,191.7,128.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.7,128.8v-26.2c0-2.5,2-4.5,4.5-4.5h3.1l0-10.1c0-2.2-0.9-4.3-2.4-5.8c-1.6-1.6-3.6-2.4-5.8-2.4 L59,79.5c-4.5,0-8.3,3.7-8.3,8.2l-0.1,55.7c0,4.6,3.7,8.3,8.2,8.3l132,0.1c4.6,0,8.3-3.7,8.3-8.2l0-10.3h-3 C193.7,133.4,191.7,131.3,191.7,128.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.7,128.8v-26.2c0-2.5,2-4.5,4.5-4.5h3.1l0-10.1c0-2.2-0.9-4.3-2.4-5.8c-1.6-1.6-3.6-2.4-5.8-2.4 L59,79.5c-4.5,0-8.3,3.7-8.3,8.2l-0.1,55.7c0,4.6,3.7,8.3,8.2,8.3l132,0.1c4.6,0,8.3-3.7,8.3-8.2l0-10.3h-3 C193.7,133.4,191.7,131.3,191.7,128.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.7,128.8v-26.2c0-2.5,2-4.5,4.5-4.5h3.1l0-10.1c0-2.2-0.9-4.3-2.4-5.8c-1.6-1.6-3.6-2.4-5.8-2.4 L59,79.5c-4.5,0-8.3,3.7-8.3,8.2l-0.1,55.7c0,4.6,3.7,8.3,8.2,8.3l132,0.1c4.6,0,8.3-3.7,8.3-8.2l0-10.3h-3 C193.7,133.4,191.7,131.3,191.7,128.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191,76.8L59,76.7c-3,0-5.8,1.2-7.9,3.3c-2.1,2.1-3.3,4.9-3.3,7.9l-0.1,55.7c0,6.1,5,11.1,11.1,11.1 l132,0.1c6.1,0,11.1-5,11.1-11.1l0.1-55.7C202.2,81.8,197.2,76.8,191,76.8z M199.2,143.7c0,4.5-3.7,8.2-8.3,8.2l-132-0.1 c-4.6,0-8.2-3.7-8.2-8.3l0.1-55.7c0-4.5,3.7-8.2,8.3-8.2l132,0.1c2.2,0,4.3,0.9,5.8,2.4c1.6,1.6,2.4,3.6,2.4,5.8l0,10.1h-3.1 c-2.5,0-4.5,2-4.5,4.5v26.2c0,2.5,2,4.5,4.5,4.5h3L199.2,143.7z"
  })))))), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 89.2,
    className: "st2",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 107.9,
    className: "st2",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 126.5,
    className: "st2",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.6,
    y: 89.2,
    className: "st3",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.6,
    y: 107.9,
    className: "st3",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.6,
    y: 126.5,
    className: "st3",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.7,
    y: 89.2,
    className: "st2",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.7,
    y: 107.9,
    className: "st3",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.7,
    y: 126.5,
    className: "st3",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.6,
    y: 89.2,
    className: "st2",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.6,
    y: 107.9,
    className: "st2",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.6,
    y: 126.5,
    className: "st2",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 89.2,
    className: "st2",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 107.9,
    className: "st3",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 126.5,
    className: "st3",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.9,
    y: 89.2,
    className: "st2",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.9,
    y: 107.9,
    className: "st2",
    width: 15.7,
    height: 15.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.9,
    y: 126.5,
    className: "st3",
    width: 15.7,
    height: 15.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCueAppIcon);
export default __webpack_public_path__ + "static/media/Cue_App_Icon.020903b4824e99fb85a0cb8a264c2341.svg";
export { ForwardRef as ReactComponent };